export const baseURL = "https://stream-sell.de.r.appspot.com/";
export const secretKey = "NeverMissMyTarget@12345";
export const projectName = "Stream Sell";
